export default {
  'menu-nav': {
    menu: 'Menu',
    'ciders-and-spirits': 'Ciders',
    'high-altitude': 'High altitude',
    'savoir-faire': 'Savoir-faire',
    contacts: 'Contacts',
    home: 'Home',
    back: 'Back',
  },
  news: 'News',
}
